<app-funnel-shell>
  <div class="funnel-card">
    @if (existingAccount()) {
      <h1>{{ 'funnel.check_email.existing_title' | translate }}</h1>
      <p class="funnel-card__intro">{{ 'funnel.check_email.existing_body' | translate }}</p>
    } @else {
      <h1>{{ 'funnel.check_email.title' | translate }}</h1>
      <p class="funnel-card__intro">{{ 'funnel.check_email.body' | translate }}</p>
    }
    <p class="funnel-card__footnote">{{ 'funnel.check_email.spam_hint' | translate }}</p>
  </div>
</app-funnel-shell>
